<div class="process-manager-header" fxLayout="row wrap">
  <h2 class="mat-h2">{{ data?.headingText }}</h2>
  <span fxFlex></span>
  <button [attr.aria-label]="_TEXT_close" mat-icon-button (click)="bottomSheetRef.dismiss()">
    <mat-icon>close</mat-icon>
  </button>
  <p class="mat-body-1" fxFlex="100">{{ data?.headingDescription }}</p>
  <mat-progress-bar *ngIf="_pollingProcessIds?.length" color="accent" mode="buffer"></mat-progress-bar>
</div>
<p *ngIf="!data?.incompleteProcessIds?.length && !data.completeProcesses?.length" i18n>There are no processes right now.</p>
<mat-list>
  <mat-list-item *ngFor="let details of processDetails; trackBy: 'id' | mtnaTrackByProperty" [@expandInOut]>
    <mat-progress-spinner
      matListIcon
      [attr.aria-label]="details.status"
      [diameter]="32"
      [class.success]="details.status === 'COMPLETED'"
      [color]="details.status !== 'FAILED' ? 'accent' : 'warn'"
      mode="determinate"
      [value]="details.completed"
    >
    </mat-progress-spinner>
    <h3 matLine>{{ details.status + ' - ' + details.id }}</h3>
    <p matLine i18n>{{ details.completed }} percent complete</p>
    <a
      *ngIf="!!data.processDownloadUrl && details.completed === 100 && details.status === 'COMPLETED'"
      download
      i18n-aria-label
      mat-raised-button
      class="process-manager__download-button"
      color="primary"
      target="_blank"
      [attr.aria-label]="details | getI18nDownloadLabel"
      [attr.href]="data.processDownloadUrl! + '/' + details.id"
    >
      <span i18n>Download</span>
      <mat-icon>cloud_download</mat-icon>
    </a>
  </mat-list-item>
</mat-list>
